<template>
  <div class="quicklink" style="margin-top:20px">
    <img src="../assets/img/express_lane.png" alt="" srcset="" />
    <div class="quick-bot clear">
      <li class="left" v-for="(item, index) in quicklinklist" :key="index">
        <div class="single-link">
          <a
            target="_blank"
            class="ahref"
            :href="item.href"
            v-if="item.href != ''"
          >
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </a>
          <div v-else-if="index == 0" class="ahref" @click="Professionals()">
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </div>
          <div
            v-else-if="index == 1"
            class="ahref"
            @click="handleOpen('http://jxjggs.zhujianpeixun.com/')"
          >
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </div>
          <!-- Erjianpage -->
          <!-- Gongrenpage -->
          <div v-else-if="index == 2" class="ahref" @click="Threetype()">
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </div>
          <div v-else-if="index == 3" class="ahref" @click="Erjianpage()">
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </div>
          <!-- <div v-else-if="index == 7" class="ahref" @click="Anquanyuan()">
                  <div class="icon-box">
                  <span class="icon iconfont" v-html="item.icon"></span>
                </div>
                <h3>{{item.title}}3333</h3>
              </div> -->
          <div v-else-if="index == 4" class="ahref" @click="Gongrenpage()">
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </div>
          <div v-else-if="index == 5" class="ahref" @click="comingsoon()">
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </div>
          <div
            v-else
            class="ahref"
            @click="toJXTrain('http://jxtzzy.zhujianpeixun.com/')"
          >
            <div class="icon-box">
              <span class="icon iconfont" v-html="item.icon"></span>
            </div>
            <h3>{{ item.title }}</h3>
          </div>
        </div>
      </li>
    </div>
    <img src="../assets/img/bar.png" alt="" srcset="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      quicklinklist: [
        {
          href: "",
          icon: "&#xe601;",
          title: "住房和城乡建设领域施工现场专业人员"
        },
        {
          href: "",
          icon: "&#xe876;",
          title: "培训机构承诺公示平台"
        },
        {
          href: "",
          icon: "&#xe619;",
          title: "安管人员培训平台"
        },
        {
          href: "",
          icon: "&#xe617;",
          title: "注册师继续教育"
        },
        {
          href: "",
          icon: "&#xe6db;",
          title: "房地产估价师继续教育"
        },
        {
          href: "",
          icon: "&#xe634;",
          title: "燃气从业人员系统"
        },
        {
          href: "",
          icon: "&#xe600;",
          title: "特种作业从业人员初始培训"
        }
      ]
    };
  },
  methods: {
    handleOpen(val) {
      window.open(val);
    },
    Anquanyuan() {
      this.$router.push({ path: "/anquanyuan" });
    },
    comingsoon() {
      this.$router.push({ path: "/comingsoon" });
    },
    NotLike() {
      this.$Message.warning("暂未开放");
      // this.$router.push({path: '/comingsoon'});
    },
    Professionals() {
      this.$router.push({ path: "/professionals" });
    },
    Threetype() {
      this.$router.push({ path: "/threetype" });
    },
    Erjianpage() {
      this.$router.push({ path: "/erjian" });
    },
    Gongrenpage() {
      this.$router.push({ path: "/gongren" });
    },
    toJXTrain(val) {
      window.open(val);
    }
  }
};
</script>

<style lang="less" scoped>
.clear {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/quicklink.vue